import { Reducer } from 'redux';
import { PbiAdminActionTypes } from './actions';
import { IPbiReport, IPbiDataset } from '../business-objects/types';

interface IPbiAdminState {
  reports: IPbiReport[];
  activeReport: IPbiReport;
  datasets: IPbiDataset[];
}
// Type-safe initialState!
const initialState = {
  reports: [],
  datasets: [],
  activeReport: null,
};

type IPbiAdminStoreState = Readonly<IPbiAdminState>;

const reducer: Reducer<IPbiAdminStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case PbiAdminActionTypes.SEARCH: {
      let _state = { ...state };
      _state = { ..._state, reports: action.value };
      return _state;
    }
    case PbiAdminActionTypes.SETACTIVEREPORT: {
      let _state = { ...state };
      _state = { ...state, activeReport: action.value };
      return _state;
    }
    case PbiAdminActionTypes.EDIT: {
      let _state = { ...state };
      _state.reports = [
        ..._state.reports.map((x) =>
          x.id == action.value.id ? { ...x, ...action.value } : x
        ),
      ];
      return _state;
    }
    case PbiAdminActionTypes.GET_DATASETS: {
      let _state = { ...state };
      _state = { ..._state, datasets: action.value };
      return _state;
    }
    case PbiAdminActionTypes.SAVENEW: {
      let _state = { ...state };
      _state.reports = [..._state.reports, action.value];
      return _state;
    }
    case PbiAdminActionTypes.DELETE: {
      let _state = { ...state };
      _state.reports = state.reports.filter((x) => x.id != action.value.id);
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
